// extracted by mini-css-extract-plugin
export default {"CountBadge":"_CountBadge--oUec0","FadeOut":"_FadeOut--PWIdh"};